import {DocumentNode} from 'graphql';
import {ServiceContainer} from '../Service/ServiceContainer/ServiceContainer';

export const useRunMutation = () => async (mutation: DocumentNode, variables: Record<string, any>) => ServiceContainer.graphQlClient.getClient().mutate({mutation, variables});
